import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import DomiciliationReportActions, {
  DomiciliationReportTypes,
} from '../Redux/DomiciliationReportRedux'
import { notificationFail } from '../Redux/NotificationActions'

// Manual fetchEpic — the CRUD default epic calls Api.domiciliationReport.get() with no arguments,
// but this endpoint requires centerId. We write a manual epic instead.
const fetchEpic = (action$, store, { Api }) =>
  action$.ofType(DomiciliationReportTypes.getRequest)
    .mergeMap(({ centerId }) =>
      Observable.fromPromise(
        Api.domiciliationReport.get(centerId)
          .then(r => r)
          .catch(e => e)
      ).flatMap((response) => {
        if (!(response.status >= 200 && response.status < 300)) {
          return [DomiciliationReportActions.getFailure(response)]
        }
        return [DomiciliationReportActions.getSuccess(response.data)]
      })
    )

const fetchAllEpic = (action$, store, { Api }) =>
  action$.ofType(DomiciliationReportTypes.getAllRequest)
    .mergeMap(({ page }) =>
      Observable.fromPromise(
        Api.domiciliationReport.getAll(page || 1)
          .then(r => r)
          .catch(e => e)
      ).flatMap((response) => {
        if (!(response.status >= 200 && response.status < 300)) {
          return [DomiciliationReportActions.getAllFailure(response)]
        }
        return [DomiciliationReportActions.getAllSuccess(response.data)]
      })
    )

const exportEpic = (action$, store, { Api }) =>
  action$.ofType(DomiciliationReportTypes.exportRequest)
    .mergeMap(({ centerId }) => (
      Observable
        .fromPromise(
          Api.domiciliationReport.export(centerId)
            .then(response => response)
            .catch(error => error)
        )
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              DomiciliationReportActions.exportFailure('Falló la descarga'),
            ]
          }

          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()

          return [DomiciliationReportActions.exportSuccess()]
        })
    ))

const exportAllEpic = (action$, store, { Api }) =>
  action$.ofType(DomiciliationReportTypes.exportAllRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(
          Api.domiciliationReport.exportAll()
            .then(response => response)
            .catch(error => error)
        )
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              DomiciliationReportActions.exportAllFailure('Falló la descarga'),
            ]
          }

          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()

          return [DomiciliationReportActions.exportAllSuccess()]
        })
    ))

export const domiciliationReportEpic = combineEpics(
  fetchEpic,
  fetchAllEpic,
  exportEpic,
  exportAllEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/DomiciliationReportObservable.js